// quiz类目列表
const CATEGORY_LIST = [
    // {
    //     category_id: 4,
    //     category_name: 'Hot Topic'
    // },
    {
        category_id: 5,
        category_name: 'Gossip'
    },
    {
        category_id: 6,
        category_name: 'Movie&TV'
    },
    {
        category_id: 7,
        category_name: 'Yummy'
    },
    {
        category_id: 8,
        category_name: 'Music&Sports'
    },
    {
        category_id: 9,
        category_name: 'For You!'
    },
    {
        category_id: 12,
        category_name: 'BTS'
    },
    {
        category_id: 13,
        category_name: 'Disney'
    },
    {
        category_id: 14,
        category_name: 'Love'
    },
    {
        category_id: 15,
        category_name: 'Beauty'
    },
    {
        category_id: 16,
        category_name: 'Friendship'
    },
    {
        category_id: 17,
        category_name: 'Kpop'
    },
    {
        category_id: 18,
        category_name: 'Recommend'
    },
    {
        category_id: 19,
        category_name: 'Family'
    },
    {
        category_id: 20,
        category_name: 'Animal'
    },
    {
        category_id: 21,
        category_name: 'Celebrity'
    },
    {
        category_id: 22,
        category_name: 'Asia'
    },
    {
        category_id: 23,
        category_name: 'Movie'
    },
    {
        category_id: 24,
        category_name: 'Sports'
    }
];

// quiz Tag
const QUIZ_TAG_TREE = [
    {
        tag_id: 512,
        tag_one_name: 'Movies&TV',
        tag_two: [
            {
                tag_id: 916,
                tag_two_name: 'Comedy'
            },
            {
                tag_id: 664,
                tag_two_name: 'Thriller'
            },
            {
                tag_id: 515,
                tag_two_name: 'Romance'
            },
            {
                tag_id: 553,
                tag_two_name: 'Horror'
            },
            {
                tag_id: 917,
                tag_two_name: 'Action'
            },
            {
                tag_id: 918,
                tag_two_name: 'Sci-Fi'
            },
            {
                tag_id: 919,
                tag_two_name: 'Crime'
            },
            {
                tag_id: 920,
                tag_two_name: 'War'
            },
            {
                tag_id: 557,
                tag_two_name: 'Cartoon'
            },
            {
                tag_id: 513,
                tag_two_name: 'Super Hero'
            },
            {
                tag_id: 523,
                tag_two_name: 'Other'
            }
        ]
    },
    {
        tag_id: 563,
        tag_one_name: 'Games'
    },
    {
        tag_id: 525,
        tag_one_name: 'Music'
    },
    {
        tag_id: 517,
        tag_one_name: 'Sports',
        tag_two: [
            {
                tag_id: 518,
                tag_two_name: 'Basketball'
            },
            {
                tag_id: 535,
                tag_two_name: 'Football'
            },
            {
                tag_id: 523,
                tag_two_name: 'Other'
            }
        ]
    },
    {
        tag_id: 545,
        tag_one_name: 'Relationship',
        tag_two: [
            {
                tag_id: 546,
                tag_two_name: 'Love'
            },
            {
                tag_id: 574,
                tag_two_name: 'Friendship'
            },
            {
                tag_id: 597,
                tag_two_name: 'Family'
            },
            {
                tag_id: 523,
                tag_two_name: 'Other'
            }
        ]
    },
    {
        tag_id: 509,
        tag_one_name: 'Celebrity',
        tag_two: [
            {
                tag_id: 532,
                tag_two_name: 'Asia'
            },
            {
                tag_id: 571,
                tag_two_name: 'Kpop'
            },
            {
                tag_id: 510,
                tag_two_name: 'Euramerican Celebrity'
            },
            {
                tag_id: 523,
                tag_two_name: 'Other'
            }
        ]
    },
    {
        tag_id: 520,
        tag_one_name: 'General',
        tag_two: [
            {
                tag_id: 536,
                tag_two_name: 'Food'
            },
            {
                tag_id: 526,
                tag_two_name: 'Animal'
            },
            {
                tag_id: 541,
                tag_two_name: 'Event'
            },
            {
                tag_id: 521,
                tag_two_name: 'Beauty'
            },
            {
                tag_id: 523,
                tag_two_name: 'Other'
            }
        ]
    }
];

export {
    CATEGORY_LIST,
    QUIZ_TAG_TREE
};



// WEBPACK FOOTER //
// ./src/pages/add-quiz/initdata.js